import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurrentUserData } from '@core/interfaces';
import { UserInfoService } from '@core/services/user-info.service';
import { ChannelsService } from '@core/services/channels.service';
import { SubjectService } from '@core/services/subject.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-about-channel',
    templateUrl: 'about-channel.component.html',
    styleUrls: ['about-channel.component.scss']
})

export class AboutChannelComponent implements OnInit, OnDestroy {
    public updateDescGroup: FormGroup | undefined;
    public show = false;
    public description: string | undefined;
    channelIds: number;
    channels = [];
    paramsChannelId: any;

    constructor(
        private _fb: FormBuilder,
        private _userInfoService: UserInfoService,
        private _channelService: ChannelsService,
        private route: ActivatedRoute,
        private subject: SubjectService
    ) {
    }

    ngOnInit() {
        this._formBuilder();
        this._currentUserData();
        this.route.params
            .subscribe(params => {
                this.paramsChannelId = params.id;
            });
    }

    private _currentUserData() {
        this._userInfoService._userInfo
            .subscribe((data: CurrentUserData) => {
                this.description = data.channel.description;
                this.channelIds = data.channel.id;
                this.updateDescGroup.patchValue({
                    desc: data.channel.description
                });
            });
    }

    private _formBuilder() {
        this.updateDescGroup = this._fb.group({
            desc: [null, Validators.required]
        });
    }

    public showForm() {
        this.show = !this.show;
    }

    public save() {
        const formData = {
            description: this.updateDescGroup.get('desc').value
        };
        this._channelService.updateChannel(this.channelIds, formData)
            .subscribe((data: any) => {
                this.description = this.updateDescGroup.get('desc').value;
                this.show = !this.show;
            });
    }

    ngOnDestroy() {
    }
}
